import {
 computed, unref,
} from 'vue';
import ResortsRepositoryBackbone from '@/js/common/Domain/Repository/Resorts';
import { useCountriesRepository } from '@entities/country';
import { useHotelsRepository, mapHotel } from '@entities/hotel';
import { useOperatorRepository } from '@entities/operator';
import {
    useResortsRepository, mapResorts, processResortsAdapters, type IBackboneResort,
} from '@entities/resort';
import { useRoomsRepository } from '@entities/room';
import { useFirstPaymentDefinitionRepository } from '@entities/firstPaymentDefinition';
import { useTourProductsRepository } from '@entities/tourProduct';

import { filterByBonusMiles } from '../../filterTourProducts/lib/filterByBonusMiles';
import { filterByMirCashback } from '@features/tourProduct/filterTourProducts';
import createTourProducts from './createTourProducts';

export default function () {
    const { countries } = useCountriesRepository();
    const { resorts, setResorts } = useResortsRepository();
    const { hotels } = useHotelsRepository();
    const { tourProducts } = useTourProductsRepository();
    const { operators } = useOperatorRepository();
    const { rooms } = useRoomsRepository();
    const { firstPaymentDefinitions } = useFirstPaymentDefinitionRepository();

    const searchedResorts = computed(() => mapResorts(unref(resorts), unref(countries)));

    const collectedHotels = computed(() => mapHotel(unref(hotels), unref(countries), unref(searchedResorts)));

    const collectedTourProducts = computed(() => createTourProducts(unref(tourProducts), unref(operators), unref(collectedHotels), unref(rooms), unref(firstPaymentDefinitions)));

    const hasTourProductsWithBonusMiles = computed(() => unref(collectedTourProducts)?.some((tourProduct) =>filterByBonusMiles(tourProduct)));

    ResortsRepositoryBackbone.repository.on('add', (data: { collection: Backbone.Collection<IBackboneResort> }) => {
        setResorts(processResortsAdapters(data.collection.models));
    });

    const hasTourProductsWithMirCashback = computed(() =>
        unref(collectedTourProducts).some((tp) => filterByMirCashback(tp)),
    );

    return {
        searchedTourProducts: collectedTourProducts,
        hasTourProductsWithBonusMiles,
        hasTourProductsWithMirCashback,
    };
}
